<template>
    <div v-if="selectedViewMode==='sidebar'" class="sidebar-root">
        <div class="sidebar-header vcs-table-header">
            <div class="sidebar-title">{{ title }}</div>
            <div class="sidebar-close-button" @click="closeSidebar" />
            <div
                class="sidebar-filter-button vcs-table-header-filter"
                @click="showFilter"
                :class="{active: filteredLayoutValues.length > 0}"
                :title="filterTitle(layoutType)"
            />
        </div>
        <div class="sidebar-content">
            <div
                    v-for="(valueData, index) in filteredItemsArray"
                    :key="index"
                    class="sidebar-entry"
                    :class="{selected: valueData.id === selected}"
                    :value="valueData.id"
                    @click="updateLayoutValue(valueData.id)"
            >{{ valueData.name }}</div>
        </div>
        <TableFilters
            :key="layoutType"
            ref="sidebarFilters"
            :filters="filters"
            :allowGroupingResults="false"
            @change="onFiltersChange"
        />
    </div>
    <div v-else class="sidebar-collapsed" @click="openSidebar"/>
</template>

<script>
    import TableFilters from "../Table/Filter/TableFilters.vue"
    import i18n from "../../i18n";

    export default {
        name: "CedexDependenciesSidebar",
        components: {TableFilters},
        props: {
            viewMode:   String,
            layoutType: String,
            selected:   String,
            items:      Object
        },
        data() {
            return {
                selectedViewMode: this.viewMode,
                filteredLayoutValues: []
            }
        },
        methods: {
            async updateLayoutValue(value) {
                if (await this.$confirmLeaveDialog()) {
                    this.$emit('updateView', 'layoutValue', value);
                }
            },
            closeSidebar() {
                this.selectedViewMode = 'tablerows';
                this.$emit('updateView', 'viewMode', this.selectedViewMode);
            },
            openSidebar() {
                this.selectedViewMode = 'sidebar';
                this.$emit('updateView', 'viewMode', this.selectedViewMode);
            },
            showFilter() {
                this.$refs.sidebarFilters.activeFilter = this.layoutType;
            },
            onFiltersChange(filterData) {
                this.filteredLayoutValues = filterData[this.layoutType];
            },
            filterTitle(columnId) {
                // check available filters
                if (!this.filteredLayoutValues.length) {
                    return '';
                }
                let filterData = false;
                this.filters.forEach(iteratingFilter => {
                    if (iteratingFilter.name === columnId) {
                        filterData = iteratingFilter.data;
                    }
                });
                if (filterData === false) {
                    return '';
                }
                // extract filter names
                let texts = [];
                filterData.forEach(filter => {
                    if (this.filteredLayoutValues.includes(filter.id)) {
                        texts.push(filter.name);
                    }
                });
                // join names with max 10 results and a '+ x more' option
                let output;
                if (texts.length > 10) {
                    output = texts.slice(0, 10).join('\r\n') + '\r\n+ ' + (texts.length - 10) + ' ' + i18n.t('more');
                } else {
                    output = texts.join('\r\n');
                }
                return output;
            }
        },
        computed: {
            itemsArray() {
                let itemsArray = this.items;
                itemsArray = Object.keys(itemsArray).map((function(key) {
                    return {id: key, name: (this.layoutType !== 'surveyType' ? key + ' - ' : '') + itemsArray[key]};
                }).bind(this));

                itemsArray.sort((a, b) => (a.name > b.name) ? 1 : -1);

                return itemsArray
            },
            filteredItemsArray() {
                if (this.filteredLayoutValues.length === 0) {
                    return this.itemsArray;
                }
                return this.itemsArray.filter(element => this.filteredLayoutValues.includes(element.id));
            },
            title() {
                let title;
                switch(this.layoutType) {
                    case 'componentCode': title = 'Component Code'; break;
                    case 'surveyType':    title = 'Survey Type'; break;
                    case 'isoCode':       title = 'ISO Code'; break;
                }

                return title;
            },
            filters() {
                return [{
                    name:  this.layoutType,
                    title: this.title,
                    data:  this.itemsArray
                }];
            }
        }
    }
</script>

<style scoped>
    div.sidebar-collapsed {
        width: 10px;
        height: 56px;
        border-right: 1px solid var(--table-header-border);
        position: absolute;
        background-color: transparent; /* transparent because it would have the same semi transparent color of the underlying element */
        background-image: url("../../assets/icons/table/arrow_right.svg");
        background-position: center;
        background-size: 16px;
        cursor: pointer;
        z-index: 2;
    }
    div.sidebar-collapsed:hover {
        background-color: var(--toolbar-background);
    }

    div.sidebar-root {
        display: flex;
        flex-flow: column;
        width: 224px;
        overflow: hidden;
    }

    div.sidebar-root > div.sidebar-header {
        flex: none;
        border-right: 1px solid var(--table-header-border);
    }
    div.sidebar-root > div.sidebar-header > div.sidebar-close-button {
        background: url('../../assets/icons/table/arrow_left.svg') no-repeat center;
        width: 24px;
        height: 56px;
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        z-index: 2;
    }
    div.sidebar-root > div.sidebar-header > div.sidebar-close-button:hover {
        background-color: var(--toolbar-background);
    }

    div.sidebar-root > div.sidebar-header > div.sidebar-filter-button {
        right: 24px;
    }

    div.sidebar-content {
        overflow-y: auto;
        flex-grow: 1;
    }
    div.sidebar-content > div.sidebar-entry {
        font-size: 12px;
        text-overflow: ellipsis;
        height: 32px;
        padding: 8px;
        overflow: hidden;
        white-space:nowrap;
        text-align: left;
    }
    div.sidebar-content > div.sidebar-entry.selected {
        border: 2px solid var(--sc-blue-dark);
        padding: 6px;
        color: var(--sc-blue-dark);
    }
    div.sidebar-content > div.sidebar-entry:nth-child(even) {
        background-color: var(--sidebar-odd-background);
    }
</style>